export enum PlatForm {
  TriPort = 1,
  CloudPort = 3,
  StudyStat = 11,
  RaspberryAI =12
}
